export type BookingProvider = 'medfile' | 'medchart';

export function buildProviderQuery(provider: BookingProvider): string {
  const params = new URLSearchParams();
  params.set('provider', provider);
  return params.toString();
}

export function appendProviderQuery(url: string, provider: BookingProvider): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${buildProviderQuery(provider)}`;
}
